import React, { useState } from 'react';
import { XIcon, CameraIcon } from 'lucide-react';
interface UserProfilePopupProps {
  onClose: () => void;
}
export const UserProfilePopup: React.FC<UserProfilePopupProps> = ({
  onClose
}) => {
  const [activeTab, setActiveTab] = useState<'profile' | 'password'>('profile');
  const [profileData, setProfileData] = useState({
    fullName: 'Admin User',
    email: 'admin@sellup.com',
    phone: '+65 9123 4567',
    department: 'Administration',
    profileImage: ''
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const handleProfileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setProfileData({
      ...profileData,
      [name]: value
    });
  };
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setPasswordData({
      ...passwordData,
      [name]: value
    });
  };
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    if (activeTab === 'profile') {
      console.log('Profile data submitted:', profileData);
    } else {
      console.log('Password data submitted:', passwordData);
    }
    onClose();
  };
  return <div className="absolute right-0 mt-2 w-96 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-829">
      <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-830">
        <h3 className="text-lg font-medium text-gray-900" data-id="element-831">User Profile</h3>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-832">
          <XIcon className="h-5 w-5" data-id="element-833" />
        </button>
      </div>
      <div className="p-4" data-id="element-834">
        <div className="flex space-x-4 mb-4" data-id="element-835">
          <button className={`flex-1 py-2 text-sm font-medium rounded-md ${activeTab === 'profile' ? 'bg-blue-50 text-blue-600' : 'text-gray-500 hover:bg-gray-50'}`} onClick={() => setActiveTab('profile')} data-id="element-836">
            Profile
          </button>
          <button className={`flex-1 py-2 text-sm font-medium rounded-md ${activeTab === 'password' ? 'bg-blue-50 text-blue-600' : 'text-gray-500 hover:bg-gray-50'}`} onClick={() => setActiveTab('password')} data-id="element-837">
            Change Password
          </button>
        </div>
        {activeTab === 'profile' ? <form onSubmit={handleSubmit} className="space-y-4" data-id="element-838">
            <div className="flex justify-center" data-id="element-839">
              <div className="relative" data-id="element-840">
                <div className="h-24 w-24 rounded-full bg-gray-200 overflow-hidden" data-id="element-841">
                  {previewImage ? <img src={previewImage} alt="Profile preview" className="w-full h-full object-cover" data-id="element-842" /> : <div className="flex items-center justify-center h-full text-3xl font-medium text-gray-500" data-id="element-843">
                      {profileData.fullName.split(' ').map(n => n[0]).join('').toUpperCase()}
                    </div>}
                </div>
                <label htmlFor="profile-image" className="absolute bottom-0 right-0 bg-blue-600 text-white p-1 rounded-full cursor-pointer" data-id="element-844">
                  <CameraIcon className="h-4 w-4" data-id="element-845" />
                </label>
                <input id="profile-image" type="file" accept="image/*" className="hidden" onChange={handleImageChange} data-id="element-846" />
              </div>
            </div>
            <div data-id="element-847">
              <label htmlFor="fullName" className="block text-sm font-medium text-gray-700" data-id="element-848">
                Full Name
              </label>
              <input type="text" id="fullName" name="fullName" value={profileData.fullName} onChange={handleProfileChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-849" />
            </div>
            <div data-id="element-850">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-851">
                Email
              </label>
              <input type="email" id="email" name="email" value={profileData.email} onChange={handleProfileChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-852" />
            </div>
            <div data-id="element-853">
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-854">
                Phone
              </label>
              <input type="text" id="phone" name="phone" value={profileData.phone} onChange={handleProfileChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-855" />
            </div>
            <div data-id="element-856">
              <label htmlFor="department" className="block text-sm font-medium text-gray-700" data-id="element-857">
                Department
              </label>
              <input type="text" id="department" name="department" value={profileData.department} onChange={handleProfileChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-858" />
            </div>
            <div className="flex space-x-3" data-id="element-859">
              <button type="button" onClick={onClose} className="flex-1 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-860">
                Cancel
              </button>
              <button type="submit" className="flex-1 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-861">
                Save
              </button>
            </div>
          </form> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-862">
            <div data-id="element-863">
              <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700" data-id="element-864">
                Current Password
              </label>
              <input type="password" id="currentPassword" name="currentPassword" value={passwordData.currentPassword} onChange={handlePasswordChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-865" />
            </div>
            <div data-id="element-866">
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700" data-id="element-867">
                New Password
              </label>
              <input type="password" id="newPassword" name="newPassword" value={passwordData.newPassword} onChange={handlePasswordChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-868" />
            </div>
            <div data-id="element-869">
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700" data-id="element-870">
                Confirm New Password
              </label>
              <input type="password" id="confirmPassword" name="confirmPassword" value={passwordData.confirmPassword} onChange={handlePasswordChange} className={`mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${passwordData.newPassword && passwordData.confirmPassword && passwordData.newPassword !== passwordData.confirmPassword ? 'border-red-500' : 'border-gray-300'}`} data-id="element-871" />
              {passwordData.newPassword && passwordData.confirmPassword && passwordData.newPassword !== passwordData.confirmPassword && <p className="mt-1 text-sm text-red-600" data-id="element-872">
                    Passwords do not match
                  </p>}
            </div>
            <div className="flex space-x-3" data-id="element-873">
              <button type="button" onClick={onClose} className="flex-1 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-874">
                Cancel
              </button>
              <button type="submit" className="flex-1 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" disabled={!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword || passwordData.newPassword !== passwordData.confirmPassword} data-id="element-875">
                Update Password
              </button>
            </div>
          </form>}
      </div>
    </div>;
};